/**
 * Builds a public edit-page URL using the same title sanitization as the admin panel.
 * The numeric id is the canonical route key; the title segment is cosmetic.
 */
export const generateEditPageLink = (
  title: string,
  id: number | string
): string => {
  const slug = (title || '').replace(/\s+|\/|\\|#/g, '-')
  return `/edit-pages/${slug}/${id}`
}
